<template>
  <div>
    <div v-if="token > ''" class="dolu_vic">
      <div class="row">
        <div class="col-1"></div>

        <div class="col-10 bg-transparent">
          <card class="bg-transparent" plain>
              <h3 class="text-center bold-text">
                COVID je kompletní řešení pro analýzu a statistiku NGS sekvenačních dat viru SARS-CoV-2.
              </h3>
              <h3 class="text-center bold-text">
                Jednotným způsobem zpracovává veškerá potřebná data, připravuje je pro <a href="https://clades.nextstrain.org/" target="_blank" class="black_link">NextClade</a>, <a href="https://www.gisaid.org/" target="_blank" class="black_link">GISAID</a> a poskytuje grafické interaktivní pohledy pro snadné porozumění vývoje viru v ČR.
              </h3>
              <h3 class="text-center bold-text">
                Díky stejnému zpracování a společnému uložení všech získaných vzorků ze všech laboratoří dosáhneme potřebné kvality vstupních dat pro následné zpracování.
              </h3>
              <h3 class="text-center bold-text">
                Zajišťujeme podporu uživatelů při laboratorním zpracování vzorků i při pořizování a analýze vstupních dat. Poskytujeme čistá normalizovaná (anonymizovaná, statistická) data Ústavu molekulární genetiky Akademie věd a dalším subjektům pro jejich následné zpracování a vizualizace.
              </h3>
          </card>
        </div>

        <div class="col-1">
        </div>
      </div>

      <div class="row">
        <div class="col-6 ">
          <card plain>
            <div class="logo">
              <a class="" aria-label="logo" href="https://www.bioxsys.cz/" target="_new">
                <div class="logo-img">
                    <img src="/img/bioxsys.svg" alt="">
                </div>
              </a>
            </div>
              <p class="card-description">
              </p>
          </card>
        </div>

        <div class="col-6">
          <card plain>
            <div class="logo">
              <a class="" aria-label="logo" href="https://www.biovendor.cz/" target="_new">
                <div class="logo-img">
                    <img src="/img/BG_BVLM_rgb.svg" alt="">
                </div>
              </a>
            </div>
              <p class="card-description">
              </p>
          </card>
        </div>
      </div>

      <div class="row dolu_min">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card type="warning"
                      icon="fas fa-hospital"
                      small-title="Total Users"
                      :title="dabo_subjects">
            <div slot="footer">
              <i class="fas fa-info"></i>
              ---
            </div>
          </stats-card>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card type="info"
                      icon="fas fa-project-diagram"
                      small-title="Total Projects"
                      :title="dabo_projects">
            <div slot="footer">
              <i class="fas fa-info"></i>
              ---
            </div>
          </stats-card>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card type="danger"
                      icon="fas fa-vials"
                      small-title="Total Examinations"
                      :title="dabo_examinations">
            <div slot="footer">
              <i class="fas fa-info"></i>
              ---
            </div>
          </stats-card>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card type="primary" icon="fas fa-expand-arrows-alt" small-title="Total Lineages" :title="dabo_lineages">
            <div slot="footer">
              <i class="fas fa-info"></i>
              ---
            </div>
          </stats-card>
        </div>

      </div>


      <div class="row">
        <div class="col-md-12 mr-auto ml-auto">
          <div class="card">
            <div class="card-header mr-auto ml-auto"> PANGO lineages
            </div>
            <div class="card-body mr-auto ml-auto">
              <slot name="title-content">
                <div class="row">
                  <div class="col-sm-7">
                    <div class="numbers pull-left">
                      <slot name="title"></slot>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="pull-right">
                      <slot name="title-label"></slot>
                    </div>
                  </div>
                </div>
              </slot>
              <slot name="subtitle"></slot>
              <la-cartesian narrow  :data="dabo_pan_lineage" :width="800">
                <la-bar prop="value"></la-bar>
                <la-x-axis :fontSize="15" prop="name"></la-x-axis>
                <la-y-axis :fontSize="15" gridline></la-y-axis>
                <la-tooltip></la-tooltip>
              </la-cartesian>
            </div>

            <div class="card-footer">
              <slot name="footer">
                <hr>
                <div class="row">
                  <div class="col-sm-7">
                    <div class="footer-title">
                      <slot name="footer-title"></slot>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="pull-right">
                      <slot name="footer-right"></slot>
                    </div>
                  </div>
                </div>
              </slot>
            </div>
          </div>
        </div>

        <div class="col-md-12 mr-auto ml-auto">
          <div class="card">
            <div class="card-header mr-auto ml-auto"> Clade Assignment
            </div>
            <div class="card-body mr-auto ml-auto">
              <slot name="title-content">
                <div class="row">
                  <div class="col-sm-7">
                    <div class="numbers pull-left">
                      <slot name="title"></slot>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="pull-right">
                      <slot name="title-label"></slot>
                    </div>
                  </div>
                </div>
              </slot>
              <slot name="subtitle"></slot>
              <la-cartesian narrow  :data="dabo_next_clade" :width="800">
                <la-bar prop="value"></la-bar>
                <la-x-axis :fontSize="15" prop="name"></la-x-axis>
                <la-y-axis :fontSize="15" gridline></la-y-axis>
                <la-tooltip></la-tooltip>
              </la-cartesian>
            </div>

            <div class="card-footer">
              <slot name="footer">
                <hr>
                <div class="row">
                  <div class="col-sm-7">
                    <div class="footer-title">
                      <slot name="footer-title"></slot>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="pull-right">
                      <slot name="footer-right"></slot>
                    </div>
                  </div>
                </div>
              </slot>
            </div>
          </div>
        </div>

      </div>

      <div v-if="biovendor" class="row dolu_min">
        <div class="col-3">
          <card class="vyska" plain>
            <h5 class="hesla">Key Features:</h5>
            <p class="card-description">
              <ul>
                <li>All-in-one cloud analysis</li>
                <li>High level of Quality Control</li>
                <li>Epidemiological information</li>
                <li>Store all your variants in database</li>
                <li>De-novo or Reference based assembly method</li>
                <li>Clade Assignment</li>
                <li>Pango Lineages</li>
                <li>Phylogenetic Tree</li>
                <li>Direct export to NextClade</li>
                <li>Easy upload to GiSAID</li>
              </ul>
            </p>
          </card>
        </div>

        <div class="col-3">
          <card class="vyska" plain>
            <h5 class="hesla">Ready for Sequencing Kit:</h5>
            <p class="card-description">
              <ul>
                <li>Paragon Genomics (CleanPlex® SARS-CoV-2 Panel)</li>
              </ul>
            </p>
          </card>
        </div>

        <div class="col-3">
          <card class="vyska" plain>
            <h5 class="hesla">Sequencing Technology compatible:</h5>
            <p class="card-description">
              <ul>
                <li>Illumina</li>
                <li>MGI</li>
                <li>Genapsys</li>
                <li>ThermoFisher Ion Torrent</li>
              </ul>
            </p>
          </card>
        </div>

        <div class="col-3">
          <card class="vyska" plain>
            <h5 class="hesla">Bioinformatician workflow:</h5>
            <p class="card-description">
              <ul>
                <li>FastQC</li>
                <li>fastp</li>
                <li>Bowtie 2</li>
                <li>SAMtools</li>
                <li>Freebyes</li>
                <li>viral-ngs</li>
                <li>Picard</li>
                <li>NextClade</li>
                <li>Pangolin</li>
                <li>MAFFT</li>
              </ul>
            </p>
          </card>
        </div>
      </div>

      <div v-else class="row dolu_min">
        <div class="col-3">
          <card class="vyska" plain>
            <h5 class="hesla">Key Features:</h5>
            <p class="card-description">
              <ul>
                <li>All-in-one cloud analysis</li>
                <li>High level of Quality Control</li>
                <li>Epidemiological information</li>
                <li>Store all your variants in database</li>
                <li>De-novo or Reference based assembly method</li>
                <li>Clade Assignment</li>
                <li>Pango Lineages</li>
                <li>Phylogenetic Tree</li>
                <li>Direct export to NextClade</li>
                <li>Easy upload to GiSAID</li>
              </ul>
            </p>
          </card>
        </div>

        <div class="col-3">
          <card class="vyska" plain>
            <h5 class="hesla">Sequencing Kit compatible:</h5>
            <p class="card-description">
              <ul>
                <li>Paragon Genomics (CleanPlex® SARS-CoV-2 Panel)</li>
                <li>Swift Amplicon® SARS-CoV-2 Panel</li>
                <li>QIAGEN</li>
                <li>Illumina</li>
                <li>Twist Bioscience</li>
              </ul>
            </p>
          </card>
        </div>

        <div class="col-3">
          <card class="vyska" plain>
            <h5 class="hesla">Sequencing Technology compatible:</h5>
            <p class="card-description">
              <ul>
                <li>Illumina</li>
                <li>MGI</li>
                <li>Genapsys</li>
                <li>ThermoFisher Ion Torrent</li>
              </ul>
            </p>
          </card>
        </div>

        <div class="col-3">
          <card class="vyska" plain>
            <h5 class="hesla">Bioinformatician workflow:</h5>
            <p class="card-description">
              <ul>
                <li>FastQC</li>
                <li>fastp</li>
                <li>Bowtie 2</li>
                <li>SAMtools</li>
                <li>Freebyes</li>
                <li>viral-ngs</li>
                <li>Picard</li>
                <li>NextClade</li>
                <li>Pangolin</li>
                <li>MAFFT</li>
              </ul>
            </p>
          </card>
        </div>
      </div>

      <div class="row dolu_min">
        <div class="col-12">
          <card plain>
            <div class="row">
              <div class="col-12">
                <h4 class="hesla">Important sources:</h4>
              </div>

              <div class="col-3">
                <a class="" aria-label="logo" href="https://virus.img.cas.cz/" target="_new">
                  <div class="logo-img">
                      <img src="/img/logo_img.png" alt="">
                  </div>
                </a>
              </div>

              <div class="col-3">
                <a class="" aria-label="logo" href="https://cov-lineages.org/index.html" target="_new">
                  <div class="logo-img">
                      <img src="/img/pango.png" alt="">
                  </div>
                </a>
              </div>

              <div class="col-3">
                <a class="" aria-label="logo" href="https://clades.nextstrain.org/" target="_new">
                  <div class="logo-img">
                      <img src="/img/nextclade.png" alt="">
                  </div>
                </a>
              </div>

              <div class="col-3">
                <a class="" aria-label="logo" href="https://www.gisaid.org/" target="_new">
                  <div class="logo-img">
                      <img src="/img/gisaid.png" alt="">
                  </div>
                </a>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>


    <div v-else class="wrapper dolu_nav">
      <div class="">
        <el-carousel :interval="10000" :arrow="never" height="650px">
          <el-carousel-item>
            <div class="content-center minvyska" style="background-image: url('img/FotkyFoto_348408708_L.jpg'); width: 100%; background-position: center; position: relative; background-repeat: repeat; background-size: cover; min-height: 650px;">
              <h1 class="title text-center dolu_podnav_h1 covidtext">COVID</h1>
              <h2 class="title text-center dolu_podnav_h2"> Kontrola kvality sekvenačních dat.  </h2>
                <div class="col-md-8 mr-auto ml-auto">

                </div>
              <div class="text-center"></div>
            </div>
          </el-carousel-item>

          <el-carousel-item>
            <div class="content-center minvyska" style="background-image: url('img/FotkyFoto_228721174_M.jpg'); width: 100%; background-position: center; position: relative; background-repeat: repeat; background-size: cover; min-height: 650px;">
              <h1 class="title text-center dolu_podnav_h1 covidtext">COVID</h1>
              <h2 class="title text-center dolu_podnav_h2"> Epidemiologický formulář dle databáze GiSAID. </h2>
                <div class="col-md-8 mr-auto ml-auto">

                </div>
              <div class="text-center"></div>
            </div>
          </el-carousel-item>

          <el-carousel-item>
            <div class="content-center minvyska" style="background-image: url('img/FotkyFoto_353455568_M.jpg'); width: 100%; background-position: center; position: relative; background-repeat: repeat; background-size: cover; min-height: 650px;">
              <h1 class="title text-center dolu_podnav_h1 covidtext">COVID</h1>
              <h2 class="title text-center dolu_podnav_h2"> Jednoduchá filtrace, výběr finálních sekvencí pro NextClade. </h2>
                <div class="col-md-8 mr-auto ml-auto">

                </div>
              <div class="text-center"></div>
            </div>
          </el-carousel-item>

          <el-carousel-item>
            <div class="content-center minvyska" style="background-image: url('img/p_05.jpg'); width: 100%; background-position: center; position: relative; background-repeat: repeat; background-size: cover; min-height: 650px;">
              <h1 class="title title text-center dolu_podnav_h1 covidtext">COVID</h1>
              <h2 class="title text-center dolu_podnav_h2"> Technická podpora, export dat pro další zpracování. </h2>
                <div class="col-md-8 mr-auto ml-auto">

                </div>
              <div class="text-center"></div>
            </div>
          </el-carousel-item>

        </el-carousel>

      </div>


      <div class="col-md-12 bg_color_main8 pt-2"></div>

      <div class="about-description text-center bg_color_main3">
        <div class="col-md-12">
          <div class="container pt-5 pb-5">
            <div class="row pt-5">
              <div class="col-md-8 ml-auto mr-auto text-center">
                <h2 class="title text-black">
                  <b>Co vám aplikace COVID nabízí?</b>
                </h2>
              </div>
            </div>

            <div class="row pb-5">
              <div class="col-md-3 bg_color_main4_padding">
                <div
                  class="bg_color_main4"
                  style="background-image: url('img/bg_cov_02.jpg')"
                >
                  <div class="info info-hover">
                    <div class="icon icon-circle">
                      <i class="fas fa-shield-alt" style="color: green"></i>
                    </div>
                    <h4 class="title main_size_covid2">Secure</h4>
                    <p class="description text-2">
                      Splňuje hlavní požadavky na zabezpečení a šifrování
                      sekvenačních dat.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-3 bg_color_main4_padding">
                <div
                  class="bg_color_main4"
                  style="background-image: url('img/bg_cov_02.jpg')"
                >
                  <div class="info info-hover">
                    <div class="icon icon-circle">
                      <i class="fas fa-cloud-upload-alt" style="color: blue"></i>
                    </div>
                    <h4 class="title main_size_covid2">All-in-one analýza</h4>
                    <p class="description text-2">
                      Využívá de-novo aasembly nebo reference based
                      bioinformatickou analýzu sekvenačních dat (amplikon nebo
                      enchriment kity)
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-3 bg_color_main4_padding">
                <div
                  class="bg_color_main4"
                  style="background-image: url('img/bg_cov_02.jpg')"
                >
                  <div class="info info-hover">
                    <div class="icon icon-circle">
                      <i class="fas fa-database" style="color: red"></i>
                    </div>
                    <h4 class="title main_size_covid2">Databáze variant</h4>
                    <p class="description text-2">
                      Jeho součástí je databáze všech variant nalezených v genomu
                      SARS-CoV-2 s přehledem jednotlivých mutací viru.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-3 bg_color_main4_padding">
                <div
                  class="bg_color_main4"
                  style="background-image: url('img/bg_cov_02.jpg')"
                >
                  <div class="info info-hover">
                    <div class="icon icon-circle">
                      <i class="fas fa-viruses" style="color: orange"></i>
                    </div>
                    <h4 class="title main_size_covid2">
                      Epidemiologické informace
                    </h4>
                    <p class="description text-2">
                      Umožňuje vyplnit formulář obsahující informace o vzorku dle
                      standardu databáze GiSAID.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-3 bg_color_main4_padding">
                <div
                  class="bg_color_main4"
                  style="background-image: url('img/bg_cov_02.jpg')"
                >
                  <div class="info info-hover">
                    <div class="icon icon-circle">
                      <i class="fas fa-poll-h" style="color: black"></i>
                    </div>
                    <h4 class="title main_size_covid2">Zařazení do Klád</h4>
                    <p class="description text-2">
                      Zahrnuje možnost srovnání analyzovaných dat s referenční
                      sekvencí a tím možnost zařazení do tzv. klád.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-3 bg_color_main4_padding">
                <div
                  class="bg_color_main4"
                  style="background-image: url('img/bg_cov_02.jpg')"
                >
                  <div class="info info-hover">
                    <div class="icon icon-circle">
                      <i class="fas fa-bezier-curve" style="color: purple"></i>
                    </div>
                    <h4 class="title main_size_covid2">Pango Lineages</h4>
                    <p class="description text-2">
                      Zařazení sekvence do konkrétní linie (britská,
                      jihoafrická...) dle Pango nomenklatury.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-3 bg_color_main4_padding">
                <div
                  class="bg_color_main4"
                  style="background-image: url('img/bg_cov_02.jpg')"
                >
                  <div class="info info-hover">
                    <div class="icon icon-circle">
                      <i class="fas fa-server" style="color: #098DBA"></i>
                    </div>
                    <h4 class="title main_size_covid2">Propojení s NextClade</h4>
                    <p class="description text-2">
                      Díky propojení s nástrojem NextClade lze data přehledně
                      vizualizovat.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-3 bg_color_main4_padding">
                <div
                  class="bg_color_main4"
                  style="background-image: url('img/bg_cov_02.jpg')"
                >
                  <div class="info info-hover">
                    <div class="icon icon-circle">
                      <i class="fas fa-cloud-upload-alt" style="color: pink"></i>
                    </div>
                    <h4 class="title main_size_covid2">Sdílení na GiSAID</h4>
                    <p class="description text-2">
                      Formátuje FASTA data do podoby splňující kritéria sdílení na
                      GiSAID serveru.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import { Card, Table, TableColumn, Divider, Carousel, CarouselItem } from 'element-ui'
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard';
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard';
  import LineChart from 'src/components/UIComponents/Charts/LineChart';
  import BarChart from 'src/components/UIComponents/Charts/BarChart';
  import PieChart from 'src/components/UIComponents/Charts/PieChart';
  import Loading from 'src/components/Layout/LoadingMainPanel.vue'
  import TaskList from './Widgets/TaskList'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';


  const tooltipOptions = {
    tooltipFillColor: "rgba(0,0,0,0.5)",
    tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipFontSize: 14,
    tooltipFontStyle: "normal",
    tooltipFontColor: "#fff",
    tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipTitleFontSize: 14,
    tooltipTitleFontStyle: "bold",
    tooltipTitleFontColor: "#fff",
    tooltipYPadding: 6,
    tooltipXPadding: 6,
    tooltipCaretSize: 8,
    tooltipCornerRadius: 6,
    tooltipXOffset: 10,
  };


  export default {
    components: {
      Card,
      TaskList,
      ChartCard,
      LineChart,
      BarChart,
      PieChart,
      StatsCard,
      Table,
      TableColumn,
      Divider,
      Carousel,
      CarouselItem,
    },

    computed: {
      ...mapState({
        token: state => state.token,
        biovendor: state => state.biovendor,

        dabo_pan_lineage: state => state.dabo_pan_lineage,
        dabo_next_clade: state => state.dabo_next_clade,
        dabo_subjects: state => state.dabo_subjects,
        dabo_projects: state => state.dabo_projects,
        dabo_examinations: state => state.dabo_examinations,
        dabo_lineages: state => state.dabo_lineages,
        dabo_mutations: state => state.dabo_mutations,

      }),

      ...mapGetters({

      }),

    },


    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {
        statsCards: [
          {
            type: 'warning',
            icon: 'nc-icon nc-globe',
            title: 'Total Projects',
            value: '11',
            footerText: 'Updated now',
            footerIcon: 'nc-icon nc-refresh-69'
          },
          {
            type: 'danger',
            icon: 'nc-icon nc-vector',
            title: 'Total Examinations',
            value: 'dabo_stat_2',
            footerText: 'pre-paid',
            footerIcon: 'nc-icon nc-bell-55'
          },

        ],



      }
    },


    methods: {
      ...mapMutations({

      }),

      ...mapActions({
        a_anon_overview: 'a_anon_overview',

      }),


      fetchEventsList () {

      },

      cancelAutoUpdate () {
      },


    },


    beforeMount () {
    },

    created () {
  
    },

    mounted () {
      // this.examinations.forEach(row => {
      //   if (row.status === 7) {
      //     this.$refs.examinationsTable.toggleRowSelection(row);
      //   }
      // });

      this.a_anon_overview();
    },

    beforeDestroy () {
    },

    afterDestroy () {
    },






  }

</script>
<style scoped>
  .main-panel {
    padding-top: 90px !important;
    padding-left: 220px !important;
    padding-right: 220px !important;
  }

  .main-panel > .content {
      min-height: calc(100vh - 10px) !important;
  }

  .full-panel {
    padding-top: 50px !important;
  }

.el-card {
  border: 0px !important;
}

.bg-transparent {
  background-color: transparent !important;

}

.black_link {
  color: black !important;
}

.bold-text {
  font-weight: 900;
}


.logo-img {
  height: 100px !important;
}

.vyska {
  min-height: 400px !important;
}

.dolu_vic {
  padding-top: 80px !important;
  padding-right: 220px !important;
}

.dolu_min {
  padding-top: 25px !important;
}

.dolu_nav {
  padding-top: 60px !important;
}

.dolu_podnav {
  padding-top: 120px !important;
}

.el-carousel__item {
  min-height: 650px !important;
}

.el-minvyska {
  min-height: 650px !important;
}


.dolu_podnav_h1  {
  padding-top: 20px !important;


}

.dolu_podnav_h2  {
  font-size: 42px !important;
  font-weight: 900;
  padding-top: 120px !important;
}


.covidtext {
    position: absolute;
    top: 30%;
    right: 50%;
    transform: translate(50%,-50%);
    text-transform: uppercase;
    font-family: verdana;
    font-size: 18em;
    font-weight: 900;
    color: #f5f5f5;
    text-shadow: 1px 1px 1px #919191,
        1px 2px 1px #919191,
        1px 3px 1px #919191,
        1px 4px 1px #919191,
        1px 5px 1px #919191,
        1px 6px 1px #919191,
        1px 7px 1px #919191,
        1px 8px 1px #919191,
        1px 9px 1px #919191,
        1px 10px 1px #919191,
    1px 18px 6px rgba(16,16,16,0.4),
    1px 22px 10px rgba(16,16,16,0.2),
    1px 25px 35px rgba(16,16,16,0.2),
    1px 30px 60px rgba(16,16,16,0.4);
}


body {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #000;
}

.dolu_podnav_h2 {
  padding-top: 400px !important;
  position: relative;
  font-family: sans-serif;
  text-transform: uppercase;
  font-size: 2em;
  letter-spacing: 4px;
  overflow: hidden;
  background: linear-gradient(90deg, #000, #fff, #000);
  background-repeat: no-repeat;
  background-size: 80%;
  animation: animate 5s linear infinite;
  -webkit-background-clip: text;
  -webkit-text-fill-color: rgba(255, 255, 255, 0);
}

@keyframes animate {
  0% {
    background-position: -500%;
  }
  100% {
    background-position: 500%;
  }
}

</style>
